"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Facts_1 = require("../../../types/facts/Facts");
const Facts_2 = require("../../../types/sports/football/Facts");
exports.footballFacts = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Facts_2.FootballSpecificFact), Facts_1.SubstitutionFact), Facts_1.BreakFact), Facts_1.PeriodFact), Facts_1.ClockFact);
exports.footballFactNameMap = {
    CORNER: 'corner',
    GOAL: 'goal',
    YELLOW_CARD: 'yellow card',
    RED_CARD: 'red card',
    FREE_KICK: 'free kick',
    FOUL: 'foul',
    OFFSIDE: 'offside',
    SHOT_ON_TARGET: 'shot on target',
    SHOT_OFF_TARGET: 'shot off target',
    PENALTY_SHOOTOUT_MISS: 'penalty missed',
    PENALTY_SHOOTOUT_GOAL: 'penalty scored',
    PENALTY_AWARDED: 'penalty awarded',
    POSSESSION_CHANGED: 'possession change'
};
exports.footballStatKeyToNameMap = {
    corners: 'Corners',
    fouls: 'Fouls',
    goals: 'Goals',
    offsides: 'Offsides',
    penaltiesMissed: 'Penalties Missed',
    penaltiesAwarded: 'Penalties Awarded',
    freeKicks: 'Free Kicks',
    possession: 'Possession',
    redCards: 'Red Cards',
    shotsOnTarget: 'Shots On Target',
    shotsOffTarget: 'Shots Off Target',
    totalShots: 'Total Shots',
    yellowCards: 'Yellow Cards',
    substitutions: 'Substitutions'
};
// tslint:disable-next-line variable-name
exports.FootballFactStatMap = {
    [Facts_2.FootballSpecificFact.YELLOW_CARD]: 'yellowCards',
    [Facts_2.FootballSpecificFact.RED_CARD]: 'redCards',
    [Facts_2.FootballSpecificFact.GOAL]: 'goals',
    [Facts_2.FootballSpecificFact.FREE_KICK]: 'freeKicks',
    [Facts_2.FootballSpecificFact.PENALTY_AWARDED]: 'penaltiesAwarded',
    [Facts_2.FootballSpecificFact.PENALTY_SHOOTOUT_GOAL]: 'penaltiesShootoutGoal',
    [Facts_2.FootballSpecificFact.OFFSIDE]: 'offsides',
    [Facts_2.FootballSpecificFact.CORNER]: 'corners',
    [Facts_2.FootballSpecificFact.SHOT_ON_TARGET]: 'shotsOnTarget',
    [Facts_2.FootballSpecificFact.SHOT_OFF_TARGET]: 'shotsOffTarget',
    [Facts_1.SubstitutionFact.SUBSTITUTION]: 'substitutions',
    [Facts_2.FootballSpecificFact.FOUL]: 'fouls'
};
//# sourceMappingURL=Facts.js.map